import { Stepper as MuiStepper, StepperProps } from "@mui/material";

type Props = StepperProps;

export const Stepper = ({ children, ...props }: Props) => {
  return <MuiStepper {...props}>{children}</MuiStepper>;
};
